<!--
 * @Description: 发票条目组件
--> 

<template>
	<div class="invoice-item">
		<div class="item-title">
			<van-checkbox :name="item.pid"
				checked-color="#1677FF"
				icon-size="16px"
				v-model="item.active"
				@click="changeCheck(item)">
				账期：{{item.fpny}}
			</van-checkbox>
		</div>
		<div style="padding: 9px 34px;">
			<!-- <div class="item-info">
        <span class="info-name">水量：</span>
        <span class="info-value">29m³</span>
      </div> -->
			<div class="item-info">
				<span class="info-name">用户号：</span>
				<span class="info-value">{{item.yhh}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">用户名称：</span>
				<span class="info-value">{{item.yhmc}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">地址：</span>
				<span class="info-value">{{item.ysdz}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">金额：</span>
				<span class="info-value"
					style="color:#2C82C9;">
					{{item.fpje}}元
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "InvoiceItem",
	components: {},
	props: {
		item: Object
	},
	data() {
		return {
			checked: false
		};
	},
	created() {
	},
	methods: {
		changeCheck(item) {
			this.$emit("changecheck", item);
		}
	},
	watch: {
	}
};
</script>

<style lang="less" scoped>
.invoice-item {
	background: rgba(255, 255, 255, 1);
	.item-title {
		padding: 0 5px;
		height: 40px;
		border-bottom: 1px solid #cccccc;
		display: flex;
		align-items: center;
		font-size: 16px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(33, 33, 33, 1);
	}
	.item-info {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(33, 33, 33, 1);
		display: flex;
		.info-name {
			width: 76px;
		}
		.info-value {
			width: calc(~"100% - 76px");
		}
	}
}
</style>